import React from "react";
import CategoryList from "../../../components/category/CategoryList";

const CategoryListPage = () => {
  return (
    <div className="container">
      <h1>List of Categories</h1>
      <CategoryList />
    </div>
  );
};

export default CategoryListPage;
